import React, { useEffect, useState } from 'react';
import { 
  CustomTab, 
  CustomTabsComponent, 
  MainContentArea,   
  MainContentAreaChildGrid,   
  TabsAndPanelsParentBox, 
  TabsBox
} from './styled';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomTabPanel from './TabPanels/CustomTabPanel';
import AISousPreview from './TabPanels/AISousPreview';
import LibraryPreview from './TabPanels/LibraryPreview';
import FeaturedPreview from './TabPanels/FeaturedPreview';
import ProfilePreview from './TabPanels/ProfilePreview';
import { Avatar, Button, Grid, Typography, useTheme } from '@mui/material';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import useCurrentUserInfo from '../../hooks/useCurrentUserInfo';
import { useDispatch } from 'react-redux';
import { chefAdminGetRecipesAndVideos } from '../../redux/actions/chefAdminActions';
// import VideosPreview from './TabPanels/VideosPreview';

function ChefPreview() {

  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useCurrentUserInfo();
  const theme = useTheme();
  const dispatch = useDispatch();

  const getCurrentTab = () => {
    const pathToIndex = {
      'aisous-chef': 0,
      'library-chef': 1,
      'featured-chef': 2,
      'profile-chef': 3,
      // 'videos-chef': 4,
    };

    const path = location.pathname.split('/').pop();
    return pathToIndex[path] || 0;
  };

  const [value, setValue] = useState(getCurrentTab());
  const [isProfile, setIsProfile] = useState(false);

  const indexToPath = {
    0: 'aisous-chef',
    1: 'library-chef',
    2: 'featured-chef',
    3: 'profile-chef',
    // 4: 'videos-chef',
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
    navigate(`/chef-page-preview/${indexToPath[newValue]}`);
  };

  const handleGetChefAdminRecipes = () => {
    dispatch(
      chefAdminGetRecipesAndVideos(userInfo?.user_id)
    );
  };

  useEffect(() => {
    setValue(getCurrentTab());
    handleGetChefAdminRecipes();
  }, [location]);


  return (
    <MainContentArea elevation={0}>
      <MainContentAreaChildGrid container >
        <TabsAndPanelsParentBox>
          {/* <Grid 
            sx={{ 
              backgroundColor: `${theme.palette.primary.main}`,
              border: `1px solid ${theme.palette.primary.main}`,
              paddingBottom: '0.5rem'
            }}
          >
            <Button 
              sx={{ 
                width: '5rem', 
                marginLeft: '0.5rem' 
              }} 
              onClick={() => navigate(-1)}
            >
              <ArrowBackOutlinedIcon color='secondary' sx={{ marginRight: '0.5rem'}} />
              <Typography color='secondary'>
                Back
              </Typography>
            </Button>
          </Grid> */}
          {/* <Grid 
            display={'flex'}
            justifyContent={'flex-start'}
            alignItems={'center'}
            width={'100%'}
            sx={{ 
              backgroundColor: `${theme.palette.primary.main}`,
              border: `1px solid ${theme.palette.primary.main}`,
              paddingLeft: '1rem',
            }}
          >
            <Avatar 
              src={userInfo?.chefProfileAvatar}
              sx={{ marginRight: '1rem' }} 
            />
            <Typography color={'secondary'}>
              {userInfo?.username}
            </Typography>
          </Grid> */}
          <TabsBox>
            <CustomTabsComponent 
              variant       = "scrollable" 
              scrollButtons = "auto" 
              value         = {value} 
              onChange      = {handleChange} 
              allowScrollButtonsMobile
            >
              <CustomTab label  = "AI Sous" />
              <CustomTab label  = "Library"    />
              <CustomTab label  = "Featured"    />
              <CustomTab label  = "Profile"   />
              {/* <CustomTab label  = "Videos"     /> */}
            </CustomTabsComponent>
          </TabsBox>
          <CustomTabPanel 
            value={value} 
            index={0} 
            sx={{width: '100%', padding: '0', height: '100%'}}
          >
            <AISousPreview />
          </CustomTabPanel>
          <CustomTabPanel 
            value={value} 
            index={1} 
            sx={{width: '100%', padding: '0', height: '100%'}}
          >
            <LibraryPreview />
          </CustomTabPanel>
          <CustomTabPanel 
            value={value} 
            index={2} 
            sx={{width: '100%', padding: '0', height: '100%'}}
          >
            <FeaturedPreview />
          </CustomTabPanel>
          <CustomTabPanel 
            value={value} 
            index={3} 
            sx={{width: '100%', padding: '0', height: '100%'}}
          >
            <ProfilePreview />
          </CustomTabPanel>
          {/* <CustomTabPanel 
            value={value} 
            index={4} 
            sx={{width: '100%', padding: '0', height: '100%'}}
          >
            <VideosPreview />
          </CustomTabPanel> */}
        </TabsAndPanelsParentBox>
      </MainContentAreaChildGrid>
    </MainContentArea>
  )
}

export default ChefPreview;